/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_Step3Inputs */

const en_gc_resources_guide_start_step3 = /** @type {(inputs: Gc_Resources_Guide_Start_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a number cell and inspect its formula in the formula bar. Check a few important totals against your original workbook.`)
};

const zh_gc_resources_guide_start_step3 = /** @type {(inputs: Gc_Resources_Guide_Start_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择数值单元格，在公式栏中检查公式。将关键合计与原始工作簿进行对照。`)
};

/**
* | output |
* | --- |
* | "Select a number cell and inspect its formula in the formula bar. Check a few important totals against your original workbook." |
*
* @param {Gc_Resources_Guide_Start_Step3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_step3 = /** @type {((inputs?: Gc_Resources_Guide_Start_Step3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_Step3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_step3(inputs)
	return zh_gc_resources_guide_start_step3(inputs)
});
export { gc_resources_guide_start_step3 as "gc.resources.guide.start.step3" }